"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";
import { cn } from "../utils";
import { SIcon } from "../../components";
const ContextMenu = ContextMenuPrimitive.Root;
const ContextMenuTrigger = ContextMenuPrimitive.Trigger;
const ContextMenuGroup = ContextMenuPrimitive.Group;
const ContextMenuPortal = ContextMenuPrimitive.Portal;
const ContextMenuSub = ContextMenuPrimitive.Sub;
const ContextMenuRadioGroup = ContextMenuPrimitive.RadioGroup;
const ContextMenuSubTrigger = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, inset, children } = _param, props = _object_without_properties(_param, [
        "className",
        "inset",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(ContextMenuPrimitive.SubTrigger, _object_spread_props(_object_spread({
        ref: ref,
        className: cn("flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm", "text-white/[0.85] hover:bg-white/10 hover:text-white", inset && "pl-8", className)
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(SIcon, {
                type: "chevron-right",
                className: "ml-auto h-4 w-4"
            })
        ]
    }));
});
ContextMenuSubTrigger.displayName = ContextMenuPrimitive.SubTrigger.displayName;
const ContextMenuSubContent = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ContextMenuPrimitive.SubContent, _object_spread({
        ref: ref,
        className: cn("z-50 min-w-[8rem] overflow-hidden rounded-lg border border-white/10", "bg-grayscale-darker p-1 text-white shadow-md", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
    }, props));
});
ContextMenuSubContent.displayName = ContextMenuPrimitive.SubContent.displayName;
const ContextMenuContent = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ContextMenuPrimitive.Portal, {
        children: /*#__PURE__*/ _jsx(ContextMenuPrimitive.Content, _object_spread({
            ref: ref,
            className: cn("z-50 min-w-[8rem] overflow-hidden rounded-lg border border-white/10", "bg-grayscale-darker p-1 text-white shadow-md", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
        }, props))
    });
});
ContextMenuContent.displayName = ContextMenuPrimitive.Content.displayName;
const ContextMenuItem = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, inset } = _param, props = _object_without_properties(_param, [
        "className",
        "inset"
    ]);
    return /*#__PURE__*/ _jsx(ContextMenuPrimitive.Item, _object_spread({
        ref: ref,
        className: cn("relative flex cursor-default select-none items-center rounded-md px-2 py-1.5 text-sm focus:outline-none", "text-white/[0.85] hover:bg-white/10 hover:text-white", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", inset && "pl-8", className)
    }, props));
});
ContextMenuItem.displayName = ContextMenuPrimitive.Item.displayName;
const ContextMenuCheckboxItem = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, children, checked } = _param, props = _object_without_properties(_param, [
        "className",
        "children",
        "checked"
    ]);
    return /*#__PURE__*/ _jsxs(ContextMenuPrimitive.CheckboxItem, _object_spread_props(_object_spread({
        ref: ref,
        className: cn("relative flex cursor-default select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm", "text-white/[0.85] hover:bg-white/10 hover:text-white", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        checked: checked
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ _jsx(ContextMenuPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ _jsx(SIcon, {
                        type: "check",
                        className: "h-4 w-4"
                    })
                })
            }),
            children
        ]
    }));
});
ContextMenuCheckboxItem.displayName = ContextMenuPrimitive.CheckboxItem.displayName;
const ContextMenuRadioItem = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, children } = _param, props = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(ContextMenuPrimitive.RadioItem, _object_spread_props(_object_spread({
        ref: ref,
        className: cn("relative flex cursor-default select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm", "text-white/[0.85] hover:bg-white/10 hover:text-white", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ _jsx(ContextMenuPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ _jsx(SIcon, {
                        type: "plus-circle",
                        className: "h-2 w-2 fill-current"
                    })
                })
            }),
            children
        ]
    }));
});
ContextMenuRadioItem.displayName = ContextMenuPrimitive.RadioItem.displayName;
const ContextMenuLabel = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, inset } = _param, props = _object_without_properties(_param, [
        "className",
        "inset"
    ]);
    return /*#__PURE__*/ _jsx(ContextMenuPrimitive.Label, _object_spread({
        ref: ref,
        className: cn("px-2 py-1.5 text-sm font-semibold text-white/[0.85]", inset && "pl-8", className)
    }, props));
});
ContextMenuLabel.displayName = ContextMenuPrimitive.Label.displayName;
const ContextMenuSeparator = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ContextMenuPrimitive.Separator, _object_spread({
        ref: ref,
        className: cn("mx-1 my-1 h-px bg-white/[0.07]", className)
    }, props));
});
ContextMenuSeparator.displayName = ContextMenuPrimitive.Separator.displayName;
const ContextMenuShortcut = (_param)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("span", _object_spread({
        className: cn("ml-auto text-xs tracking-widest text-white/50", className)
    }, props));
};
ContextMenuShortcut.displayName = "ContextMenuShortcut";
export { ContextMenu, ContextMenuTrigger, ContextMenuContent, ContextMenuItem, ContextMenuCheckboxItem, ContextMenuRadioItem, ContextMenuLabel, ContextMenuSeparator, ContextMenuShortcut, ContextMenuGroup, ContextMenuPortal, ContextMenuSub, ContextMenuSubContent, ContextMenuSubTrigger, ContextMenuRadioGroup,  };
